module.exports = __webpack_public_path__ + "static/media/robloxTakingOrder.2352d864.jpg";